var React = require('react');

function Decoration (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.35802 0C-1.48303 18.2812 1.63941 35.8436 11.7254 52.6873C20.288 73.1017 26.8946 89.8636 15.8166 124C45.6375 105.234 63.9551 107.375 85.2766 110.978C119.797 122.117 151.069 109.735 179.372 74.0536C200.797 47.044 210.305 22.8044 208.489 0.584503C208.467 0.389618 208.445 0.194794 208.421 0H156.385C156.823 2.02573 156.959 4.03143 156.788 6.02261C156.351 14.2324 150.257 26.5109 138.354 41.5162C127.046 55.7712 116.326 63.1583 107.686 64.8607C98.2992 65.9714 86.9691 61.8734 73.5448 51.2248C59.3748 39.9846 52.8058 29.8845 51.7512 20.4915C51.5516 14.8009 53.7799 7.97043 58.4364 0H2.35802Z","fill":"#42143E"}));
}

Decoration.defaultProps = {"width":"209","height":"124","viewBox":"0 0 209 124","fill":"none"};

module.exports = Decoration;

Decoration.default = Decoration;
